<template>
  <div class="categoryName">
    商业企业
  </div>
</template>
<script>
export default{
  props:['categoryName']
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/categoryName/circulationEnterprise.vue